import { fisherSciQaRegions, tfGatewayFromFS } from './constants'

export function formatUpperCaseToCapitalize (str) {
  let i
  const frags = str.toLowerCase().split('_')
  for (i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags.join(' ')
}

export function kebabToCamel (obj) {
  const newObj = {}
  for (const key in obj) {
    /* lint ignore */
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase()
      })
      newObj[camelKey] = obj[key]
    }
  }
  return newObj
}

export function debounce (fn, wait) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer) // clear any pre-existing timer
    }
    const context = this // get the current context
    timer = setTimeout(() => {
      fn.apply(context, args) // call the function if time expires
    }, wait)
  }
}
export const envTypes = {
  qa4: 'qa4',
  qa1: 'qa1',
  qa: 'qa',
  prod: 'prod',
  dev: 'dev',
  test: 'test'
}

export const domains = {
  thermofisher: {
    [envTypes.qa4]: 'https://www.qa4.thermofisher.com/',
    [envTypes.qa]: 'https://www.qa.thermofisher.com/',
    [envTypes.qa1]: 'https://www.qa.thermofisher.com/',
    [envTypes.prod]: 'https://www.thermofisher.com/'
  },
  fishersci: {
    [envTypes.qa1]: 'https://qa1.fishersci.com/',
    [envTypes.qa]: 'https://qa3.fishersci.com/',
    [envTypes.prod]: 'https://www.fishersci.com/'
  },

  ampliseq: {
    [envTypes.qa]: 'https://test.ampliseq.com/',
    [envTypes.prod]: 'https://www.ampliseq.com/',
    [envTypes.dev]: 'https://dev.ampliseq.com/'
  }
}
